import { Item } from '../../types/item.types';
import React from 'react';
import { SingleActivateButton } from '../table/SingleActivateButton';
import { SingleEditButton } from '../table/SingleEditButton';
import { SubItem } from '../../types/sub-item.types';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { tokens } from '../../../../shared/styles/core/tokens';
import { useScrollState } from '../../state/hover-and-scroll.state';

type ExpandedRowActionsProps = {
   hovering: boolean;
   setHovering: (hovering: boolean) => void;
   setDisabledHovering: (disable: boolean) => void;
   rowRef: React.RefObject<HTMLTableRowElement>;
   rowData: SubItem;
   parentItem: Item;
};

export const ExpandedRowActions = ({ hovering, rowRef, rowData, parentItem }: ExpandedRowActionsProps) => {
   const BUTTON_OFFSET = 18;

   const showButton = useScrollState((state) => !state.isScrolling && hovering);

   const offset = (rowRef.current?.getBoundingClientRect().y || 0) + (rowRef.current?.clientHeight || 1) / 2 - BUTTON_OFFSET;

   return !rowData.locked ? (
      <StyledEndOfRowButtonDiv yOffset={offset}>
         <SingleEditButton visible={showButton} rowData={rowData} parentItem={parentItem} />
         {showButton && <SingleActivateButton subItem={rowData} />}
      </StyledEndOfRowButtonDiv>
   ) : (
      <></>
   );
};

const StyledEndOfRowButtonDiv = styled.div<{ yOffset?: number }>`
   ${(props) =>
      props.yOffset !== undefined
         ? css`
            top: ${props.yOffset}px;
         `
         : css``
   }
   position: fixed;
   display: flex;
   right: 6rem;
   z-index: ${tokens.zIndex.dropdown};
`;
